import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Time Commitment';
const pageSubTitle = 'Time Commitment';
const videoKey = 'xvqaGmPjvy4';

const TimeCommitment = () => {
    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <p>
                    Time Commitment reflects how important it is to avoid treatments that require
                    ongoing time or repeated effort. This refers not to the length of recovery, but to
                    how often the treatment must be done—whether it’s a one-time procedure, something
                    occasional, or something ongoing.
                    <br/>
                    For example:
                    <br/>
                    <ul style={{ marginLeft: 16 }}>
                        <li>
                            Total Knee Replacement is a one-time procedure.
                        </li>
                        <li>
                            PRP, Cortisone, and Hyaluronic Acid Injections are considered occasional.
                        </li>
                        <li>
                            NSAIDs and Physical Therapy are ongoing treatments that require regular
                            commitment.
                        </li>
                    </ul>
                    <br/>
                    This criterion helps highlight which treatments best fit into daily life and
                    scheduling needs.
                </p>
            }
            videoKey={videoKey}
            pageType="criteria"
        />


    );

};

export default TimeCommitment;